import React from 'react';
import classNames from 'classnames';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';
import { FaSearch } from 'react-icons/fa';

import { injectIntl } from '../../util/reactIntl';
import {
  Form,
  SecondaryButton,
  Button,
  FieldSelectModern,
  IconClose,
  InlineTextButton,
} from '../../components';
import config from '../../config';
import { required } from '../../util/validators';

import css from './SignupProviderForms.css';

const Placeholder = () => (
  <div className={css.placeholderContainer}>
    <FaSearch className={css.searchIcon} />
  </div>
);

const SignupProviderToolsForm = props => {
  return (
    <FinalForm
      {...props}
      mutators={{
        ...arrayMutators,
      }}
      render={formRenderProps => {
        const {
          rootClassName,
          className,
          handleSubmit,
          onPrev,
          form,
          intl,
          form: {
            mutators: { push },
          },
          invalid,
          values,
          isModal,
          toolOptions,
        } = formRenderProps;

        const classes = classNames(rootClassName || css.root, className);

        const submitDisabled = invalid;

        const heading = intl.formatMessage({
          id: 'SignupProviderForms.toolsHeading',
        });
        const modalHeading = intl.formatMessage({
          id: 'SignupProviderForms.modalToolsHeading',
        });

        const nextButtonText = intl.formatMessage({
          id: 'SignupProviderForms.nextUpHourlyFee',
        });
        const previousButtonText = intl.formatMessage({
          id: 'SignupProviderForms.previousButton',
        });
        const addButtonText = intl.formatMessage({
          id: 'SignupProviderForms.addButton',
        });
        const okButtonText = intl.formatMessage({
          id: 'SignupProviderForms.okButton',
        });

        const point1 = intl.formatMessage({
          id: 'SignupProviderForms.toolsPoint1',
        });
        const point2 = intl.formatMessage({
          id: 'SignupProviderForms.toolsPoint2',
        });
        const point3 = intl.formatMessage({
          id: 'SignupProviderForms.toolsPoint3',
        });

        const categoryRequired = intl.formatMessage({
          id: 'SignupProviderForms.toolsCategoryRequired',
        });

        const showAddToArray = values?.tools?.length < 20;

        const locale = config.locale;
        const translation = locale === 'fi' ? 'fiTranslation' : 'enTranslation';

        // Function to filter out selected skills
        const getAvailableToolOptions = index => {
          const selectedToolIds = values.tools
            .map((item, idx) => idx !== index && item.category && item.category.key)
            .filter(Boolean);

          const availableToolOptions = toolOptions
            .filter(option => !selectedToolIds.includes(option.key))
            .sort((a, b) =>
              a[translation].localeCompare(b[translation], locale, { sensitivity: 'base' })
            );

          return availableToolOptions.map(option => ({
            ...option,
          }));
        };

        return (
          <div className={classes}>
            <Form className={css.form} onSubmit={values => handleSubmit(values, form)}>
              <div className={css.formFieldsContainer}>
                <h2 className={css.skillsHeading}>{!isModal ? heading : modalHeading}</h2>
                <FieldArray name="tools">
                  {({ fields }) => (
                    <>
                      {fields.map((name, index) => (
                        <div key={name} className={css.skillsFieldArray}>
                          <FieldSelectModern
                            id={`${name}.category`}
                            name={`${name}.category`}
                            options={getAvailableToolOptions(index)}
                            components={{ Placeholder }}
                            className={classNames(css.fieldArrayOption, css.skillsCategory)}
                            validate={required(categoryRequired)}
                            onKeyDown={e => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                                if (!invalid) {
                                  // Submit the form
                                  handleSubmit(form.getState().values, form);
                                }
                              }
                            }}
                          />
                          <span
                            className={css.skillsDelete}
                            onClick={() =>
                              fields?.length === 1 ? fields.update(index, {}) : fields.remove(index)
                            }
                          >
                            <IconClose rootClassName={css.deleteIcon} />
                          </span>
                        </div>
                      ))}
                    </>
                  )}
                </FieldArray>
                {showAddToArray && (
                  <InlineTextButton
                    type="button"
                    className={css.addToArray}
                    onClick={() => push('tools', {})}
                  >
                    {addButtonText}
                  </InlineTextButton>
                )}
                <ul className={css.pointerList}>
                  <li>{point1}</li>
                  <li>{point2}</li>
                  <li>{point3}</li>
                </ul>
              </div>
              <div className={css.submitContainer}>
                {!isModal && (
                  <SecondaryButton rootClassName={css.backButton} onClick={onPrev}>
                    {previousButtonText}
                  </SecondaryButton>
                )}
                {!isModal ? (
                  <Button rootClassName={css.nextButton} type="Submit" disabled={submitDisabled}>
                    {nextButtonText}
                  </Button>
                ) : null}
                {isModal ? (
                  <div className={css.submitContainerModal}>
                    <Button rootClassName={css.nextButton} type="Submit" disabled={submitDisabled}>
                      {okButtonText}
                    </Button>
                  </div>
                ) : null}
              </div>
            </Form>
          </div>
        );
      }}
    />
  );
};

SignupProviderToolsForm.defaultProps = {
  headingNeeded: false,
};

export default injectIntl(SignupProviderToolsForm);
